import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from "@emotion/styled";
import { useTab } from "./tabContext";
const StyledPanel = styled.div(({ style }) => ({
    padding: "16px",
    ...style,
}));
export const Panel = ({ children, value, style }) => {
    const { value: selectedValue } = useTab();
    return selectedValue === value ? _jsx(StyledPanel, { style: style, children: children }) : null;
};
//# sourceMappingURL=Panel.js.map